import React from "react";
import { useTranslation } from 'react-i18next';
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import "../../assets/css/customstyles.css";
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import OfflineDb from '../../db'
import { useHistory } from "react-router";
import AccordianList from '../../component/contentList/AccordianList'
import CardList from '../../component/contentList/CardList'


export default function AlertItemsList(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const setGlobalSpinner = useGlobalSpinnerActionsContext()
  const listOfFields = props.progarmData.programs[0].programTrackedEntityAttributes
  const fieldsToDisplay = listOfFields.filter(obj => obj.displayInList == true)

  const renderListItem = (props)=>{
    const searchHeader = []
    const searchResult = []
    const labelArr = [];
    //push alert name first
    if(props.alertdata.hasOwnProperty('alertname')){
      labelArr.push({'Alert Name': t(props.alertdata.alertname)});
    }
    fieldsToDisplay.forEach((item)=>{
      let obj = {};
      if(props.alertdata.hasOwnProperty(item.trackedEntityAttribute.id)){
        obj[item.trackedEntityAttribute.formName] = props.alertdata[item.trackedEntityAttribute.id];
        labelArr.push(obj);
      }
    })
    // push duedays last
    if(props.alertdata.hasOwnProperty('duedays')){
      labelArr.push({'Due Days': props.alertdata.duedays});
    }

    //console.log('labelArr>>', fieldsToDisplay, labelArr)

    const accordionContent = <div className="">
    {
      labelArr.map(item=>{
        for(let key in item) {
          return (
            <>
              <p 
                className={'alerts_description_fields'} //`${key =='alertname' ? "alerts_title" : "alerts_description_fields"}`
              >
                {key+' : '}  {item[key]}
              </p>
            </>
          )
        }
      })
    }
    </div>
    return (
        props.viewType == 'card'
          ?
          <CardList AccordionLabel = {labelArr.find(x => x.Name) ? labelArr.find(x => x.Name)['Name'] : ''} AccordionContent = {accordionContent} AccordionDataObject = {labelArr} TrackEntityId = {props.alertdata.instanceid} Component={'Alert'} PropsArray = {props}/>
          
          :
          <AccordianList AccordionLabel = {labelArr.find(x => x['Alert Name']) ? labelArr.find(x => x['Alert Name'])['Alert Name'] : ''} AccordionContent = {accordionContent} AccordionDataObject = {labelArr} TrackEntityId = {props.alertdata.instanceid} Component={'Alert'} PropsArray = {props}/>
        
        //
  
          
        
    )
  }
  function UpdateRecordClick(instanceid) {
    setGlobalSpinner(true)
    const activeCaseDetails = {
      'trackedEntityInstance': instanceid,
      'enrollmentId': "",
    }
    const linkContact = {
      "enabled": false,
      "linkTrackedEntityInstance": instanceid
    }
    OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
    OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
    setGlobalSpinner(false)
    history.push('/layout/registration')
  }
  return (
    <>
      {renderListItem(props)}
    </>
  );
}
